import { gql } from '@apollo/client';

/**
 * Click / View tracking mutations — the backend's public (no-auth) counters.
 *
 *   trackViews(views) — a BATCH of impressions. services/tracking.ts queues
 *                       every view (a card seen in a list, a detail page
 *                       opened) and sends them together, so scrolling a
 *                       catalog costs a request every ~1.5s instead of one
 *                       per card. The server counts each (entityType, id) at
 *                       most once per request and returns how many it counted.
 *   viewX(id)         — one view per request. Still on the backend for
 *                       installed mobile builds; the web app sends them only
 *                       when the backend is older than `trackViews`.
 *   clickX(id)        — fired when the user taps through to an entity (card
 *                       press, marker, etc.). Stays one request per click.
 *
 * All are fire-and-forget on the client.
 */
export const TRACK_VIEWS = gql`
  mutation TrackViews($views: [TrackViewInput!]!) {
    trackViews(views: $views)
  }
`;

export const VIEW_BRAND = gql`
  mutation ViewBrand($id: ID!) {
    viewBrand(id: $id)
  }
`;

export const CLICK_BRAND = gql`
  mutation ClickBrand($id: ID!) {
    clickBrand(id: $id)
  }
`;

export const VIEW_STORE = gql`
  mutation ViewStore($id: ID!) {
    viewStore(id: $id)
  }
`;

export const CLICK_STORE = gql`
  mutation ClickStore($id: ID!) {
    clickStore(id: $id)
  }
`;

export const VIEW_SHOP = gql`
  mutation ViewShop($id: ID!) {
    viewShop(id: $id)
  }
`;

export const CLICK_SHOP = gql`
  mutation ClickShop($id: ID!) {
    clickShop(id: $id)
  }
`;

export const VIEW_PROMOTION = gql`
  mutation ViewPromotion($id: ID!) {
    viewPromotion(id: $id)
  }
`;

export const CLICK_PROMOTION = gql`
  mutation ClickPromotion($id: ID!) {
    clickPromotion(id: $id)
  }
`;
